import React from 'react'
import Button from '../../atoms/Button/Button'
import { DatatableRow, DatatableCell } from '../../atoms/Datatable/Datatable'
import { Bin, Customize, Plus, Clock, Edit } from '../../atoms/NewIcons'
import ProdottoInfo from '../../molecules/ProdottoInfo/ProdottoInfo'
import { priceNotation } from '../../../utils/safe'
import Link from 'next/link'
import useTrans from '../../../hooks/useTrans'
import { Trans } from '../../atoms'
import { useDuplicaPersonalizzazione } from '../../organisms/DuplicaPersonalizzazione/DuplicaPersonalizzazione'
import { api } from '../../../utils'
import { PRODOTTI } from '../../../utils/endpoint'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { trackingAddCart } from '../../../utils/gtm'

export const DatatableCartCols = {
  prodotto: { label: <Trans chiave="Descrizione" />, mobileCols: 12 },
  personalizzazione: { label: <Trans chiave="Personalizzazione" />, width: '171px', mobileCols: 7 },
  prezzoPezzo: { label: <Trans chiave="Prezzo/Pz" />, width: '100px', mobileCols: 5 },
  quantita: { label: <Trans chiave="Quantità" />, width: '100px', mobileCols: 7 },
  totale: { label: <Trans chiave="Totale" />, width: '100px', mobileCols: 5 },
  actions: { label: '', width: '36px', mobileCols: 12 },
}

const DatatableRowCart = ({
  isPersonalizzato,
  isPrenotato,
  isSalvatoPerDopo,
  isPersonizzabile,
  MoveToLater,
  MoveToMain,
  Delete,
  articolo,
  quantita,
  id,
  nota,
  setOpen,
  setId,
  saveCodice,
  setNota,
  setDeleteOpen,
  setOpenModalQuantita,
  even,
  riga,
  carrelloMain,
}) => {
  const router = useRouter()
  const t = useTrans()
  const { service_gift } = useSelector((state) => state.servicegift)
  const NoteAction = () => {
    return (
      <div className="datatable-row-cart__note-action nobreak">
        {nota ? (
          <Button
            variant="ghost"
            colorVariant="black"
            size="medium"
            label={t('Visualizza nota')}
            className="datatable-row-cart__note-button datatable-row-cart__note-button--show"
            onClick={() => {
              setOpen(true)
              setNota(nota)
              setId(id)
            }}
          />
        ) : (
          <Button
            variant="ghost"
            colorVariant="black"
            size="medium"
            label={t('Aggiungi note')}
            className="datatable-row-cart__note-button datatable-row-cart__note-button--add"
            icon_pos="left"
            icon={<Plus />}
            onClick={() => {
              setOpen(true)
              setId(id)
              setNota(null)
            }}
          />
        )}
      </div>
    )
  }

  const SaveAction = () => {
    return (
      <Button
        variant="ghost"
        colorVariant="black"
        icon_pos="left"
        icon={<Clock />}
        size="medium"
        label={t('Salva per dopo')}
        className="datatable-row-cart__save-button"
        onClick={() => MoveToLater(id)}
        disabled={!MoveToLater}
      />
    )
  }

  const MoveToMainAction = () => {
    return (
      <Button
        variant="ghost"
        colorVariant="black"
        icon_pos="left"
        icon={<Clock />}
        size="medium"
        label={t('Sposta nel carrello')}
        className="datatable-row-cart__save-button"
        onClick={() => {
          MoveToMain(id)
          trackingAddCart({ righe_carrello: [riga] }, 'standard_order')
        }}
        disabled={!MoveToMain}
      />
    )
  }

  const DeleteButton = () => {
    return (
      <Button
        variant="ghost"
        colorVariant="black"
        icon_pos="left"
        icon={<Bin />}
        size="medium"
        label={t('Elimina prodotto')}
        className="datatable-row-cart__delete-button"
        onClick={() => {
          if (isSalvatoPerDopo) {
            Delete(id)
          } else {
            setDeleteOpen(true)
            setId(id)
          }
        }}
      />
    )
  }

  const prodottoInfoData = {
    image: articolo.main_image,
    codice: articolo.codice,
    nome: articolo.prodotto_nome,
    titolo: articolo.titolo,
    url: articolo.url,
    colore: articolo.colore?.nome,
    taglia: articolo.taglia?.nome,
  }

  const {
    checkPersonalizzazioniDisponibili,
    ModalDuplicaPersonalizzazione,
  } = useDuplicaPersonalizzazione(riga, carrelloMain)

  const cols = DatatableCartCols

  return (
    <>
      <ModalDuplicaPersonalizzazione
        onClose={() => router?.push(`/cart/personalizzazione/new/${articolo?.codice}`)}
      />
      <DatatableRow even={even} className="datatable-row-cart">
        <DatatableCell col={cols.prodotto}>
          <ProdottoInfo prodotto={prodottoInfoData} isPrenotato={isPrenotato} />
        </DatatableCell>
        {(!service_gift || service_gift?.personalizzazione) && (
          <DatatableCell col={cols.personalizzazione} className="datatable-row-cart__bspaced-cell">
            {!isPersonalizzato ? (
              isPersonizzabile && !isSalvatoPerDopo ? (
                <a>
                  <Button
                    label={t('Personalizza')}
                    variant="secondary"
                    icon={<Customize />}
                    icon_pos="left"
                    size="medium"
                    onClick={async () => {
                      const result = await api
                        .get(PRODOTTI + articolo?.codice + '/')
                        .catch((err) => console.log(err))

                      const personalizzazioniDisponibili = await checkPersonalizzazioniDisponibili(
                        result?.data?.id
                      )
                      !personalizzazioniDisponibili &&
                        router?.push(`/cart/personalizzazione/new/${articolo?.codice}`)
                    }}
                    className="customize-button"
                  />
                </a>
              ) : null
            ) : (
              <div className="customized-block">
                <span className="customized-block__icon">
                  <Customize />
                </span>
                <span className="customized-block__label">
                  <Trans chiave="Personalizzato" />
                </span>
              </div>
            )}
          </DatatableCell>
        )}
        <DatatableCell col={cols.prezzoPezzo} className="datatable-row-cart__bspaced-cell">
          {priceNotation(riga?.prezzo_unitario_netto, 3)} €
        </DatatableCell>
        <DatatableCell col={cols.quantita} className="datatable-row-cart__bspaced-cell">
          <div className="quantity-edit">
            <span className="quantity-edit__value">{quantita}</span>
            {!isSalvatoPerDopo && (
              <Button
                label={t('Modifica')}
                variant="ghost"
                icon={<Edit />}
                icon_pos="left"
                size="medium"
                xSize="small"
                onClick={() => {
                  saveCodice && saveCodice(articolo?.codice)
                  setId(id)
                  setOpenModalQuantita(true)
                }}
                className="quantity-edit__button"
              />
            )}
          </div>
        </DatatableCell>
        <DatatableCell col={cols.totale} className="datatable-row-cart__bspaced-cell">
          <b>{priceNotation(riga?.prezzo_totale_netto, 3)} €</b>
        </DatatableCell>
        <DatatableCell col={cols.actions}>
          <div>
            <div className="datatable-row-cart__actions">
              <NoteAction />
              {isSalvatoPerDopo && !isPersonalizzato && <MoveToMainAction />}
              {!isSalvatoPerDopo && !isPersonalizzato && <SaveAction />}
            </div>
            <DeleteButton />
          </div>
        </DatatableCell>
      </DatatableRow>
    </>
  )
}

export default DatatableRowCart
